import router from './index';
import {storeRouter} from "@/store/Router";
import { ElMessage } from 'element-plus'
router.beforeEach((route:any, from, next) => {
	// 动态设置标题
	if (!route.meta.title) {
		// 设置默认标题
		document.title = '巨狼养车 - 管理后台';
	}else{
		// 从路由的元信息中获取title动态标题
		document.title = route.meta.title;
	}
	// 如果是IOS设备，使用hack方法实现页面标题更新
	if (navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
		const hackIframe = document.createElement('iframe');
		hackIframe.style.display = 'none';
		hackIframe.src = '/assets/html/fixIosTitle.html?r=' + Math.random();
		document.body.appendChild(hackIframe);
		setTimeout(_ => {
			document.body.removeChild(hackIframe)
		}, 300)
	}
    storeRouter.getRouter()
    // 获取用户token，用来判断当前用户是否登录
    if (route.path === '/login') {
        next()
        return
    }
    if (localStorage.getItem('ACCESS_TOKEN')) {
        //获取state中的路由
        let routeList = storeRouter.getRouter();
        const hasRouters = routeList && routeList.length>0;

        //判断state中是否有路由，若有，进行下一步
        if ( hasRouters ) {
            next()
        } else {
            // ElMessage.warning('路由获取出错！');
            next('/login')
        }
    } else {
        next('/login')
    }
})

// router.afterEach(() => {
    
// })